import { cashPennyRoundingAdjustment, cashTotalDue } from '@/utils/cashPennyRounding'

/** @param {object|null|undefined} sale */
export function getSaleCashRoundingAdjustment (sale) {
  return Number(sale?.cash_rounding_adjustment ?? 0) || 0
}

/** @param {object|null|undefined} sale */
export function shouldShowCashRoundingOnReceipt (sale) {
  const adjustment = getSaleCashRoundingAdjustment(sale)
  if (Math.abs(adjustment) < 0.001) return false
  const method = String(sale?.payment_method || '')
  return method === 'cash' || method === 'split'
}

/**
 * Receipt display total (includes cash rounding adjustment when persisted on the sale).
 * @param {object|null|undefined} sale
 */
export function getReceiptDisplayTotal (sale) {
  return Number(sale?.total ?? 0) || 0
}

/**
 * @param {number|string|null|undefined} exactTotal
 * @param {object|null|undefined} businessInfo
 */
export function getCheckoutCashDue (exactTotal, businessInfo) {
  return cashTotalDue(exactTotal, businessInfo)
}

export { cashPennyRoundingAdjustment, cashTotalDue }
